import * as React from 'react';
import styled from "styled-components";

const SAbout = styled.div`
  flex: 1; /* Allows main content to take up the remaining horizontal space */
  padding: 5px 10px;
  `;

const About = () => {
  return (
    <SAbout>
<h5>Informacje o <b>Español Para Todos</b></h5>

<h6>Czym jest EPT?</h6>
<p><b>Español Para Todos</b> jest serwisem służącym upowszechnianiu języka hiszpańskiego. Jest przeznaczony przede wszystkim dla
osób, które uczą się tego języka lub mają ochotę rozpocząć. Nie znaczy to, że pozostałe osoby nic tutaj ciekawego nie znajdą dla siebie.
Poza gramatyką oraz słownictwem w serwisie można znaleźć sporo tekstów piosenek i poezji, różne programy mające na celu wspomagać naukę
oraz szereg katalogów z informacjami o stronach/książkach/itp. związanych z językiem hiszpańskim oraz jego nauką.<br/>
Serwis nie jest komercyjny, nie ma żadnych związków z firmami zajmującymi się językiem hiszpańskim. Jest to projekt hobbystyczny i rzadko rozwijany.</p>

<h6>Osoby zaangażowane</h6>
<p><b>Marcin</b> - wyszedł z inicjatywą stworzenia strony jeszcze będąc studentem na III roku w Akademii Górniczo-Hutniczej;
zajmuje się przede wszystkim programowaniem strony oraz jej wyglądem; w początkowej fazie istnienia strony przygotowywał również jej
zawartość.</p>
<p><b>Ania</b> - nauczycielka języka hiszpańskiego w kilku szkołach i uczelniach, m.in. w Akademii Górniczo-Hutniczej;
jej dziełem jest okazały dział z gramatyką.</p>
<p><b>Małgosia</b> - osoba, która przygotowała najwięcej materiałów dla serwisu; jej dziełem jest m.in. dział z tekstami
piosenek i poezją.</p>
<p><b>inne osoby</b> - dołożyły do serwisu cegiełki w postaci słowników tematycznych, opracowań tematycznych lub w inny sposób.</p>

<h6>Historia</h6>
<p>Pierwsza wersja <b>EPT</b> powstała jeszcze w roku 2001. Była to bardzo brzydka strona z niewielką ilością informacji i dostępna wyłącznie w sieci AGH.
Od tamtego czasu serwis przeszedł szereg metamorfoz, których efektem jest oglądany obecnie serwis.</p>

<h6>Kilka słów na koniec</h6>
<p>Mile widziane są uwagi dotyczące strony, jej przygotowania oraz zamieszczanych materiałów. Konstruktywne uwagi bardzo w cenie. Podobnie jak informacje o
zauważonych błędach.</p>

<h6>Kontakt</h6>
<p>Email (należy wcześniej usunąć dziewiątki): <b>ept99@tekidaki.pl</b></p>
    </SAbout>)
};

export default About;